<template>
  <!-- 公共头 -->
  <header id="header" v-if="isLoggedIn">
    <section class="container">
      <h1 id="logo">
        <a href="#/addPage" title="星辰物语">
          <img src="../assets/img/logo.png" width="100%" alt="星辰物语">
        </a>
      </h1>
      <div>
        <ul class="nav">
          <router-link to="/czpage" tag="li" active-class="current" exact>
            <a>购买课程</a>
          </router-link>
          <router-link to="/thinglist" tag="li" active-class="current">
            <a>物品查询</a>
          </router-link>
          <router-link to="/xclist" tag="li" active-class="current">
            <a>发放清单</a>
          </router-link>
          <router-link to="/orders" tag="li" active-class="current">
            <a>我的订单</a>
          </router-link>
          <router-link to="/download" tag="li" active-class="current">
            <a>下载账单</a>
          </router-link>
        </ul>
      </div>
      <div class="logout-container">
        <button @click="logout" class="logout-btn">退出登录</button>
      </div>
      <div class="clear"></div>
    </section>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['isLoggedIn'])
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.push('/loginadmin')
    }
  }
}
</script>

<style scoped>
.container {
  min-height: 5vh;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}

.nav li {
  margin-right: 20px;
}

.nav a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
}

.nav a:hover {
  color: #667eea;
}

.logout-container {
  display: flex;
  align-items: center;
}

.logout-btn {
  background-color: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-btn:hover {
  background-color: #5a67d8;
}
</style>